import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

import Input from './forms/parts/Input';

const plugins = { dvr: dvr(validatorjs) };

const FrogotPasswordForm = observer(({ form }) => (
  <form onSubmit={form.onSubmit}>
    <p className="forgot-password-subtitle">
      Please enter the email address registered on your account, we’ll email you
      a link to change your password
    </p>
    <div className="form-group reset-password">
      <Input field={form.$('email')} />
    </div>
    <button className="btn btn-pink" type="submit">
      Send
    </button>
  </form>
));

@inject('stores')
@observer
class ResetPassword extends Component {
  constructor() {
    super();

    const fields = [
      {
        name: 'email',
        label: 'Email Address',
        rules: 'required|email',
      },
    ];

    const hooks = {
      onSuccess() {
        // TODO endpoint
      },
      onError() {
      },
    };

    this.form = new MobxReactForm({ fields }, { plugins, hooks });
  }

  render() {
    return (
      <React.Fragment>
        <FrogotPasswordForm form={this.form} />
      </React.Fragment>
    );
  }
}
export default ResetPassword;
